<template>
    <div class="card">
        <div class="card-header text-center">
            <span>
                {{ participant.name }} - {{ survey }}
            </span>
        </div><!-- .card-header -->

        <div class="card-body">
            <div class="row">
                <div class="col-10 offset-1">

                    <div v-for="(page, idx) in pages" :key="idx">
                        <div v-for="question in page.questions" :key="question.variable">

                            <div class="row">
                                <div class="col-4 text-end fw-bold">
                                    {{ question.text['english'] }}
                                </div>
                                <div class="col-8">
                                    <!-- special json questions for survey3 -->
                                    <div v-if="['RadioBabiesStatus','RadioBabiesNicu','RadioBabiesNicuLength'].includes(question.template)">
                                        <div v-for="(baby, index) in decodeJsonData(response[question.variable])" :key="index">
                                            {{ index }}: {{ radioAnswerLabel(question.answers, baby, participant) }}<br>
                                        </div>
                                    </div>
                                    <div v-else-if="question.template == 'WeightPoundsOunces'">
                                        <div v-for="(baby, index) in decodeJsonData(response[question.variable])" :key="index">
                                            {{ index }}: 
                                            <span v-if="baby == 888">Don't know</span>
                                            <span v-else-if="baby == 999">Prefer not to respond</span>
                                            <span v-else-if="baby != null">
                                                {{ Math.floor(baby / 16) > 0 ? Math.floor(baby / 16) + ' lbs ' : '' }}
                                                {{ baby % 16 > 0 ? baby % 16 + ' oz' : '' }}
                                            </span>
                                            <br>
                                        </div>
                                    </div>
                                    <!-- look up response label for multiple answers WITH an actual response -->
                                    <div v-else-if="['CheckboxDefault','CheckboxHeader'].includes(question.template)">
                                        <div v-for="answer in question.answers" :key="answer.variable">
                                            <span v-if="response[answer.variable]" class="fs-5 fw-bold me-2">&bull;</span>
                                            {{ response[answer.variable] ? answer.label['english'] : '' }}
                                            <span v-if="response[answer.variable]" v-html="'<br>'"></span>
                                        </div>
                                    </div>
                                    <div v-else-if="['SelectDefault','SelectHeader'].includes(question.template) && response[question.variable] !== null">
                                        {{ selectOptionLabel(question.select.options, response[question.variable], participant) }}
                                    </div>
                                    <!-- default radio questions -->
                                    <div v-else-if="question.answers && response[question.variable] !== null">
                                        {{ radioAnswerLabel(question.answers, response[question.variable], participant) }}
                                    </div>
                                    <div v-else-if="question.template == 'StaticOptionalHeader'">
                                        [instructions, not a question]
                                    </div>
                                    <div v-else-if="question.hasOwnProperty('validationRules') && !response[question.variable]" style="color: red;">
                                        [no response provided]
                                    </div>
                                    <div v-else style="color: forestgreen;">
                                        {{ response[question.variable] ?? '[question not asked]' }}
                                    </div>
                                </div>
                            </div>

                        </div><!-- v-for -->
                        <hr>
                    </div><!-- v-for -->

                </div><!-- .col-10 -->
            </div><!-- .row -->
        </div><!-- .card-body -->

    </div><!-- .card -->
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../stores/surveys'

    const { setParticipant, setSurvey, loadPages, loadResponse, decodeJsonData } = useSurveysStore()
    const { survey, pages, response, participant } = storeToRefs(useSurveysStore())
    const props = defineProps(['surveyName', 'participant', 'surveyPages', 'response'])

    setParticipant(props.participant)
    setSurvey(props.surveyName)
    loadPages(props.surveyPages)
    loadResponse(props.response, props.participant)

    function radioAnswerLabel(array, val, part) {
        const answer = array.filter(obj => { return obj.value == val })
        return answer[0].label['english']
    }

    function selectOptionLabel(array, val, part) {
        const option = array.filter(obj => { return obj.value == val })
        return option[0].label['english']
    }
</script>